module.exports = __webpack_public_path__ + "static/media/dollar.7a7b9f13.png";